import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';

@Component({
    selector: 'app-years-modal',
    templateUrl: './years-modal.component.html',
    imports: [
        MatTooltipModule,
        TranslateModule,
        CommonModule,
        NgbModule,
        ModalTitleComponent,
    ]
})
export class YearsModalComponent implements OnInit {
  selectedYear: number;
  years: number[] = [
    1402, 1403, 1404, 1405, 1406, 1407, 1408, 1409, 1410, 1411, 1412, 1413,
  ];

  constructor(
    private dialogRef: MatDialogRef<YearsModalComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.selectedYear = this.data.year;
  }

  onSelectYear(year) {
    if (year < 1405) {
      this.dialogRef.close(year);
    }
  }

  activeYear(year): string {
    if (this.selectedYear == year)
      return 'tw-bg-gray-400 dark:tw-bg-primary-600 tw-text-gray-700 dark:tw-text-gray-300';
    else return 'tw-bg-gray-200 dark:tw-bg-[#5f5f70]';
  }

  onClose() {
    this.dialogRef.close();
  }
}
